import config from '../../config/config';

export const ACCEPT_NEXIO_AGREEMENT_LOAD = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_AGREEMENT_LOAD';
export const ACCEPT_NEXIO_AGREEMENT_SUCCESS = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_AGREEMENT_SUCCESS';
export const ACCEPT_NEXIO_AGREEMENT_FAILURE = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_AGREEMENT_FAILURE';
export const ACCEPT_NEXIO_PRICING_AGREEMENT_FAILURE = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_PRICING_AGREEMENT_FAILURE';
export const ACCEPT_NEXIO_PRICING_AGREEMENT_LOAD = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_PRICING_AGREEMENT_LOAD';
export const ACCEPT_NEXIO_PRICING_AGREEMENT_SUCCESS = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_PRICING_AGREEMENT_SUCCESS';
export const ACCEPT_NEXIO_SURCHARGE_AGREEMENT_FAILURE = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_SURCHARGE_AGREEMENT_FAILURE';
export const ACCEPT_NEXIO_SURCHARGE_AGREEMENT_LOAD = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_SURCHARGE_AGREEMENT_LOAD';
export const ACCEPT_NEXIO_SURCHARGE_AGREEMENT_SUCCESS = 'ACCOUNT_AGREEMENT/ACCEPT_NEXIO_SURCHARGE_AGREEMENT_SUCCESS';
export const MERCHANT_LEGAL_INFORMATION_LOAD = 'ACCOUNT_AGREEMENT/MERCHANT_LEGAL_INFORMATION_LOAD';
export const MERCHANT_LEGAL_INFORMATION_SUCCESS = 'ACCOUNT_AGREEMENT/MERCHANT_LEGAL_INFORMATION_SUCCESS';
export const MERCHANT_LEGAL_INFORMATION_FAILURE = 'ACCOUNT_AGREEMENT/MERCHANT_LEGAL_INFORMATION_FAILURE';

export function acceptTerms(acceptAccountAgreement) {
    return {
        failureActionTypeOrCreator: acceptTermsFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/accountAgreement`,
            body: acceptAccountAgreement
        },
        loadActionTypeOrCreator: ACCEPT_NEXIO_AGREEMENT_LOAD,
        successActionTypeOrCreator: acceptTermsSuccessCreator
    };
}

export function acceptPricing(acceptAccountAgreement) {
    return {
        failureActionTypeOrCreator: acceptPricingFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/accountAgreement`,
            body: acceptAccountAgreement
        },
        loadActionTypeOrCreator: ACCEPT_NEXIO_PRICING_AGREEMENT_LOAD,
        successActionTypeOrCreator: ACCEPT_NEXIO_PRICING_AGREEMENT_SUCCESS
    };
}

export function acceptSurcharge(acceptAccountAgreement) {
    return {
        failureActionTypeOrCreator: acceptSurchargeFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${config.userManagementApiUrl}/accountAgreement`,
            body: acceptAccountAgreement
        },
        loadActionTypeOrCreator: ACCEPT_NEXIO_SURCHARGE_AGREEMENT_LOAD,
        successActionTypeOrCreator: ACCEPT_NEXIO_SURCHARGE_AGREEMENT_SUCCESS
    };
}

export function fetchMerchantLegalInformation(merchantIds = []) {

    return {
        failureActionTypeOrCreator: fetchMerchantLegalInformationFailureActionCreator,
        fetchParams: {
            method: 'GET',
            url: `${config.merchantApiUrl}/merchantLegalInformation?merchantIds=${merchantIds.join(',')}`
        },
        loadActionTypeOrCreator: MERCHANT_LEGAL_INFORMATION_LOAD,
        successActionTypeOrCreator: fetchMerchantLegalInformationSuccessActionCreator
    };
}

export function fetchMerchantLegalInformationFailureActionCreator(error) {
    return {
        error,
        type: MERCHANT_LEGAL_INFORMATION_FAILURE
    };
}

export function fetchMerchantLegalInformationSuccessActionCreator(merchantLegalInformation) {
    return {
        merchantLegalInformation,
        type: MERCHANT_LEGAL_INFORMATION_SUCCESS
    };
}

export function acceptTermsFailureActionCreator(error) {
    return {
        error,
        type: ACCEPT_NEXIO_AGREEMENT_FAILURE
    };
}

export function acceptTermsSuccessCreator() {
    return {
        data: {},
        type: ACCEPT_NEXIO_AGREEMENT_SUCCESS
    };
}

export function acceptPricingFailureActionCreator(error) {
    return {
        error,
        type: ACCEPT_NEXIO_PRICING_AGREEMENT_FAILURE
    };
}

export function acceptSurchargeFailureActionCreator(error) {
    return {
        error,
        type: ACCEPT_NEXIO_SURCHARGE_AGREEMENT_FAILURE
    };
}
